import React from 'react';
import {
  Route,
  Switch,
  BrowserRouter as Router,
  Redirect,
} from 'react-router-dom';
import { routes } from 'constants/config';
import SkillsLibrary from './Library/SkillsLibrary';
import ProfileTableContainer from './Profiles/ProfileTableContainer';
import AddProfileContainer from './Profiles/AddProfileContainer';

const SkillsRoot = () => (
  <div className="LearnDashboard">
    <Router>
      <Switch>
        <Route path={routes.SKILLS.LIBRARY} component={SkillsLibrary} />
        <Route
          path={routes.SKILLS.PROFILE_ADD}
          component={AddProfileContainer}
        />
        <Route
          path={routes.SKILLS.PROFILES}
          component={ProfileTableContainer}
        />
        <Route>
          <Redirect to={routes.SKILLS.LIBRARY} />
        </Route>
      </Switch>
    </Router>
  </div>
);

export default SkillsRoot;
